import { lazy } from 'react';
export var VotingPageAsync = lazy(function () { return import('./VotingPage'); });
